/**
 * Derive a conversation title from the first prompt (or the first attachment's
 * name when there is no text).
 *
 * PII: the server scrubs the title with the conversation's token map, THEN
 * truncates it to the column cap (apps/experts/api/chat/conversations.js), and
 * detokenizes it for members on read. Scrubbing only works on WHOLE values: a
 * client-side cut through an email, PNR or card number ("jane.doe@exa",
 * "4111 1111") is no longer detectable, so its first half would be stored raw.
 * A word-boundary cut is not safe either (cards and phones contain spaces), and
 * the cut would also drop the labels ("passenger name:") the scrubber uses as
 * context. So the client NEVER shortens the title; the sidebar truncates it
 * visually (CSS), and the server is the only place it is shortened.
 */
const FALLBACK = 'New conversation';

export function deriveConversationTitle(seed: string | undefined): string {
  const text = (seed ?? '').trim();
  return text || FALLBACK;
}
